import React from "react";
import { AiOutlineRight } from "react-icons/ai";

const RightArrow = (onClick,onDisable) => {
  return (
    <div>
      <AiOutlineRight
        onClick={onClick}
        onDisable={onDisable}
        style={{ float: "right", marginTop: "220px", cursor: "pointer" }}
      />
    </div>
  );
};

export default RightArrow;
